import { useMemo } from 'react';

import useBoundStore from 'store';

const useVirtualListStyle = (defaultScreenPadding?: number) => {
  const screenPadding = useBoundStore((s) => s.screenPadding);

  return useMemo(
    () => ({
      height: `calc(100vh - ${defaultScreenPadding ? defaultScreenPadding : screenPadding}px)`,
    }),
    [screenPadding],
  );
};

export default useVirtualListStyle;
